export default function LeadershipVsManagement() {
  const columns = [
    {
      title: 'Лидерство',
      icon: 'ri-star-line',
      color: 'teal',
      items: [
        'Ведёт за собой, вдохновляет',
        'Создаёт видение будущего',
        'Формирует культуру и ценности',
        'Работает с людьми, а не с задачами',
        'Задаёт вопрос «Зачем?»',
        'Мотивирует смыслом и миссией',
        'Принимает непопулярные решения',
        'Создаёт среду для роста',
      ],
    },
    {
      title: 'Управление',
      icon: 'ri-settings-3-line',
      color: 'teal',
      items: [
        'Организует процессы',
        'Распределяет ресурсы',
        'Контролирует исполнение',
        'Работает с системами и KPI',
        'Задаёт вопрос «Как?»',
        'Мотивирует целями и бонусами',
        'Принимает операционные решения',
        'Обеспечивает стабильность',
      ],
    },
    {
      title: 'Менеджмент',
      icon: 'ri-briefcase-4-line',
      color: 'teal',
      items: [
        'Планирует и координирует',
        'Выстраивает отчётность',
        'Управляет проектами',
        'Работает с планами и дедлайнами',
        'Задаёт вопрос «Когда?»',
        'Мотивирует структурой и порядком',
        'Принимает тактические решения',
        'Обеспечивает предсказуемость',
      ],
    },
    {
      title: 'Руководство',
      icon: 'ri-shield-user-line',
      color: 'teal',
      items: [
        'Назначает ответственных',
        'Формулирует правила и стандарты',
        'Оценивает результаты',
        'Работает с полномочиями и зонами',
        'Задаёт вопрос «Кто?»',
        'Мотивирует дисциплиной и карьерой',
        'Принимает кадровые решения',
        'Обеспечивает порядок и субординацию',
      ],
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Чем отличается лидерство от управления, менеджмента и руководства
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-4xl mx-auto">
          Эти понятия часто путают, но каждое из них описывает свой аспект работы руководителя. Сильный руководитель владеет всеми четырьмя ролями и осознанно переключается между ними.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {columns.map((col, i) => (
            <div key={i} className="bg-white p-6 rounded-xl border border-gray-100">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center">
                  <i className={`${col.icon} text-xl text-white`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-base">{col.title}</h3>
              </div>
              <ul className="space-y-3">
                {col.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-xl p-6 text-center">
          <p className="text-teal-800 leading-relaxed text-sm md:text-base">
            <strong>Обучение руководителей</strong> в BusinessTraining.by развивает все четыре компетенции: от стратегического лидерства до операционного руководства. Программа строится вокруг ваших бизнес-задач, а не абстрактных моделей.
          </p>
        </div>
      </div>
    </section>
  );
}